import React from 'react'

import data from '../../../../data/waste-water-treatment-plants'
import { WasteWaterTreatmentPlantIcon } from '../../../../icons'
import LayerContent from '../../LayerContent'

import Description from './Description'
import Project from '../../Project'

const WasteWaterTreatmentPlants = () => {
  return (
    <LayerContent>
      {({ active, setActiveProject }) =>
        data.entries.map(resource => (
          <Project
            data={resource}
            setActiveProject={setActiveProject}
            active={active}
            key={resource.id}
            name="waste"
            icon={() => <WasteWaterTreatmentPlantIcon />}
          />
        ))
      }
    </LayerContent>
  )
}

export { Description as WasteWaterTreatmentPlantDescription }
export default WasteWaterTreatmentPlants
